<template>
    <portal to="modal">
        <transition leave-active-class="duration-200">
            <div v-show="show" class="fixed z-10 inset-0 overflow-y-auto ">
                <div class="flex items-end justify-center h-screen p-4 text-center sm:block sm:p-0">
                    <transition
                        enter-active-class="ease-out duration-300"
                        enter-from-class="opacity-0"
                        enter-to-class="opacity-100"
                        leave-active-class="ease-in duration-200"
                        leave-from-class="opacity-100"
                        leave-to-class="opacity-0">
                        <div v-show="show" class="fixed inset-0 transition-opacity">
                            <div class="absolute inset-0 bg-gray-500 opacity-75" @click="close"/>
                        </div>
                    </transition>

                    <div class="hidden sm:inline-block sm:align-middle sm:h-screen"></div>&#8203;

                    <transition
                        enter-active-class="ease-out duration-300"
                        enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                        leave-active-class="ease-in duration-200"
                        leave-from-class="opacity-100 translate-y-0 sm:scale-100"
                        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <div v-show="show"
                             :class="bodyClass"
                             :style="{maxHeight: 'calc(100vh - 4rem)'}"
                             aria-labelledby="modal-headline"
                             aria-modal="true" class="relative inline-block align-bottom bg-white rounded-lg text-left  overflow-y-auto overflow-x-hidden shadow-xl transform transition-all sm:align-middle sm:max-w-lg w-full" role="dialog">
                            <div
                                aria-modal="true"
                                class="relative bg-white shadow-xl transform transition-all  max-h-screen-4/5" role="dialog">
                                <div v-if="closeable" class="absolute right-0 mt-2 mr-2 z-10">
                                    <button class="text-gray-900 z-20 p-2" @click.prevent="close">
                                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                            <path clip-rule="evenodd"
                                                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                                  fill-rule="evenodd"
                                            ></path>
                                        </svg>
                                    </button>
                                </div>
                                <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                    <slot></slot>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </transition>
    </portal>
</template>

<script>
export default {
    props: {
        show: {
            default: false
        },
        maxWidth: {
            default: '2xl'
        },
        closeable: {
            default: true
        },
        bodyClass: {
            default: "",
        }
    },

    mounted() {
        document.addEventListener('keydown', this.closeOnEscape)
    },

    methods: {
        close() {
            if (this.closeable) {
                this.$emit('close', false)
            }
        },
        closeOnEscape(e) {
            if (e.key === 'Escape' && this.show) {
                this.close()
            }
        }
    },

    computed: {
        maxWidthClass() {
            return {
                'sm': 'sm:max-w-sm',
                'md': 'sm:max-w-md',
                'lg': 'sm:max-w-lg',
                'xl': 'sm:max-w-xl',
                '2xl': 'sm:max-w-2xl',
            }[this.maxWidth]
        }
    },

    watch: {
        show: {
            immediate: true,
            handler: (show) => {
                if (show) {
                    document.body.style.overflow = 'hidden'
                } else {
                    document.body.style.overflow = null
                }
            }
        }
    },

    beforeUnmount() {
        document.removeEventListener('keydown', this.closeOnEscape)
    },
}
</script>
